import { createContext, useContext } from 'react';

/** Solo `true` dentro de `/metricas/resumen` (página pública del resumen animado, shell oscuro local). */
export const MetricasResumenPublicContext = createContext(false);

export function useMetricasResumenPublicPage() {
  return useContext(MetricasResumenPublicContext);
}
